import makeLookup from './makeLookup'

var table = makeLookup('p,li,dd,rb,rt,rtc,rp,optgroup,option,tbody,tfoot,tr,td,th')
export default function(closee) {
  return !!table[closee]
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/parser/isClosedByParent.js